<script lang="ts">
	import type { ItemsSub } from '$lib/tools/graph-db/create_map_state.svelte';
	import type { CartState } from '../../handlers/cart_state.svelte';
	import type { products, sellers } from '$lib/tools/graphdb';

	import ShipmentOptions from './ShipmentOptions.svelte';
	import AddressSelector from './AddressSelector.svelte';
	import * as Card from '$lib/components/ui/card';
	import { Badge } from '$lib/components/ui/badge';
	import BuyerInput from './BuyerInput.svelte';
	import QuickCart from './QuickCart.svelte';

	import { Loc } from '$lib/tools/locale.svelte';

	let {
		cart_state,
		mode,
		open = $bindable(),
		products_sub_fn = function products_sub_fn(seller: sellers) {
			return { values: seller.Products } as ItemsSub<products>;
		}
	}: {
		cart_state: CartState;
		open?: boolean;
		mode: 'seller' | 'operator';
		products_sub_fn(seller?: sellers): ItemsSub<products>;
	} = $props();
</script>

{#if cart_state}
	<div class="space-y-6">
		<Card.Root class="shadow-sm border-border/60 gap-3">
			<Card.Header class="pb-3">
				<Card.Title class="flex items-center gap-3 text-lg">
					<Badge variant="default" class="w-6 h-6 rounded-full p-0 flex items-center justify-center text-[11px]"
						>1</Badge
					>
					{Loc('details|buyer,the')}
				</Card.Title>
			</Card.Header>
			<Card.Content class="space-y-6">
				<BuyerInput {cart_state} />
				{#if cart_state.variables.buyer}
					<AddressSelector {cart_state} />
				{/if}
			</Card.Content>
		</Card.Root>

		<Card.Root class="shadow-sm border-border/60 overflow-visible  gap-3">
			<Card.Header class="pb-3">
				<Card.Title class="flex items-center gap-3 text-lg">
					<Badge variant="default" class="w-6 h-6 rounded-full p-0 flex items-center justify-center text-[11px]"
						>2</Badge
					>
					{Loc('cart,the')}
				</Card.Title>
			</Card.Header>
			<Card.Content>
				<QuickCart {mode} {products_sub_fn} {cart_state} />
			</Card.Content>
		</Card.Root>

		<div class="mb-5">
			<ShipmentOptions {cart_state} />
		</div>
	</div>
{/if}
